var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProvider = function SvgProvider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 32.5,
    fill: "#fff",
    stroke: "#a2bc3a",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    d: "M40.42 32.05a8.36 8.36 0 1 0-10.01 0A15.46 15.46 0 0 0 20 46.62v5.1A1.29 1.29 0 0 0 21.28 53h28.28a1.29 1.29 0 0 0 1.29-1.29v-4.77a15.83 15.83 0 0 0-10.44-14.89zm-5-12.48a5.78 5.78 0 1 1 0 11.57 5.78 5.78 0 0 1 0-11.57zm12.86 30.86h-25.7v-3.8a12.9 12.9 0 0 1 7.06-11.48v4.5a5.78 5.78 0 0 0-4.5 5.64 1.29 1.29 0 1 0 2.57 0 3.21 3.21 0 0 1 6.43 0 1.29 1.29 0 1 0 2.57 0 5.78 5.78 0 0 0-4.5-5.64v-5.47a12.91 12.91 0 0 1 6.45 0v4.68a1.29 1.29 0 0 0 2.57 0v-3.69a13.3 13.3 0 0 1 7.07 11.77z"
  })));
};
export default SvgProvider;